import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@metarouter-private/mr-mui';

const DEFAULT_MESSAGE = 'No audit history for this record yet.';
const FILTERED_EMPTY_MESSAGE = 'No audit entries match these filters.';

export default function AuditLogEmptyState({ filtered = false, message = DEFAULT_MESSAGE }) {
  return (
    <Typography data-test-id="auditLogEmptyState" color="text.secondary">
      {filtered ? FILTERED_EMPTY_MESSAGE : message}
    </Typography>
  );
}

AuditLogEmptyState.propTypes = {
  filtered: PropTypes.bool,
  message: PropTypes.string,
};
